export const state = {
	context: "/",
	authLoading: true,
	loading: false,
	error: undefined,
	isPrinting: false,
	BlogPosts: [],
	showLandingBackground: true,
};
